import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Table,
  Tabs,
  Tab,
  Form,
} from "react-bootstrap";
import PermissionContext from "../../Store/permission-context";
import classes from "./Sales.module.css";
import InputRadio from "../Elements/InputRadio.jsx";
import Receipt from "./Receipt.jsx";
import TableReceipt from "./TableReceipt.jsx";
import { AutoComplete, Divider } from "rsuite";
import "rsuite/dist/rsuite.css";
import ProcessingModal from "./Modals/ProcessingModal.jsx";
import YesAndNoModal2 from "./Modals/YesAndNoModal2.jsx";

const Sales = () => {
  const PCtx = useContext(PermissionContext);
  const [valval, setvalval] = useState("");
  const [Itemname, setItemname] = useState("");
  const [ShowProcessing, setShowProcessing] = useState(false);
  const [Nop, setNop] = useState("");
  const [Nou, setNou] = useState("");
  const [PUrl, setPUrl] = useState("");
  const [Staff, setStaff] = useState("");
  const [OrderValueProcessed, setOrderValueProcessed] = useState("");
  const [display, setdisplay] = useState(false);
  const [cannotGenerate, setcannotGenerate] = useState(true);
  const [showReceipt, setshowReceipt] = useState(false);
  const [DisableAll, setDisableAll] = useState(false);
  const [Cash, setCash] = useState("");
  const [TheCreditMode, SetTheCreditMode] = useState(false);
  const [POS, setPOS] = useState("");
  const [Transfer, setTransfer] = useState("");
  const [QBulkError, setQBulkError] = useState(false);
  const [QUnitError, setQUnitError] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState(false);
  const [CheckBlur, setCheckBlur] = useState(false);
  const [AllGoodNames, setAllGoodNames] = useState([]);
  const [AllOrderedItems, setAllOrderedItems] = useState([]);
  const [AllOrderNumbers, setAllOrderNumbers] = useState([]);
  const [IgnoredOrders, setIgnoredOrders] = useState([]);
  const [PackPriceSelected, setPackPriceSelected] = useState("");
  const [UnitPriceSelected, setUnitPriceSelected] = useState("");
  const [TotalPayable, setTotalPayable] = useState(0);
  const [SurCharge, setSurCharge] = useState(0);
  const [TotalPayableWithDiscount, setTotalPayableWithDiscount] = useState(0);
  const [showDiscount, setshowDiscount] = useState(false);
  const [Discount, setDiscount] = useState("0");
  const [PaymentMode, setPaymentMode] = useState("Cash");
  const [CustomerName, setCustomerName] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("080XXXXXXXX");
  const [OpenCustomerForm, setOpenCustomerForm] = useState(true);
  const [OrderInProgress, setOrderInProgress] = useState(true);
  const [CheckOver, setCheckOver] = useState(true);
  const tableRef = useRef(null);
  const [ReceiptDetails, setReceiptDetails] = useState({});
  const [GoodsNotAvailable, setGoodsNotAvailable] = useState([]);
  const [PickedCustomerID, setPickedCustomerID] = useState("");
  const [Reload, setReload] = useState(false);
  const [ShowOK, setShowOK] = useState(false);
  const [Message, setMessage] = useState("");
  const [PaymentModePerfect, setPaymentModePerfect] = useState(false);
  const [ItemProps, setItemProps] = useState({
    ItemID: "",
    Converter: "",
    QBulk: "",
    QUnit: "",
    SoldIn: "",
    SP1: "",
    SP2: "",
    SP3: "",
    UP1: "",
    UP2: "",
    UP3: "",
    PackPriceSelected: "",
    UnitPriceSelected: "",
    PUrl: "",
  });
  var CryptoJS = require("crypto-js");
  // To load stored items from the database
  useEffect(() => {
    let Allnames = [];
    let AllIDs = [];
    const getData = async () => {
      let AllGoods = await PCtx.connectAxios("getallgoods.php", "");

      for (var y = 0; y < AllGoods.length; y++) {
        AllIDs[y] = AllGoods[y][0];
        Allnames[y] = AllGoods[y][1];
      }
    };
    // const cdd = new Date();
    // const cd = cdd.toLocaleString("en-US", { weekday: "short" });
    // getData();
    // setAllGoodNames(Allnames);
    // setOrderValue(`${cd.toUpperCase()}-`);
  }, []);

  useEffect(() => {
    const GetAllOrderNos = async () => {
      let AllOrderNos = await PCtx.connectAxios("getallordernos.php", "");
      // console.log(AllOrderNos);
      // console.log(AllOrderNos.Active);
      setAllOrderNumbers(AllOrderNos.Active);
      setIgnoredOrders(AllOrderNos.Ignored);
    };
    GetAllOrderNos();
  }, [Reload]);

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollTop = tableRef.current.scrollHeight;
    }
  }, [AllOrderedItems]);

  useEffect(() => {
    if (AllOrderedItems.length > 0) {
      setcannotGenerate(false);
    } else {
      setcannotGenerate(true);
    }
  }, [AllOrderedItems]);

  useEffect(() => {
    let Cs = Cash === "" ? 0 : parseFloat(Cash);
    let Ps = POS === "" ? 0 : parseFloat(POS);
    let Ts = Transfer === "" ? 0 : parseFloat(Transfer);
    let AllMode = Cs + Ps + Ts;
    if (
      AllMode != 0 &&
      parseFloat(AllMode) === parseFloat(TotalPayableWithDiscount)
    ) {
      setPaymentModePerfect(true);
    } else {
      setPaymentModePerfect(false);
    }
  }, [Cash, POS, Transfer, TotalPayableWithDiscount]);

  useEffect(() => {
    const Proceed = async () => {
      if (GoodsNotAvailable.length === 0) {
        let rcd = Date.now() + Math.floor(Math.random() * 100 + 0);
        rcd = rcd.toString();
        rcd = rcd.substring(2);
        rcd = "R" + rcd;
        let receiptdate =
          new Date().toDateString() + ", " + new Date().toLocaleTimeString();

        setTotalPayableWithDiscount(TotalPayableWithDiscount + SurCharge);
        let SalesData = {
          OrderData: AllOrderedItems,
          Discount: Discount,
          Payable: TotalPayable,
          PayableWithDiscount: TotalPayableWithDiscount,
          PaymentMode: PaymentMode,
          Cash: Cash === "" ? 0 : parseFloat(Cash),
          POS: POS === "" ? 0 : parseFloat(POS),
          Transfer: Transfer === "" ? 0 : parseFloat(Transfer),
          cn: CustomerName,
          pn: PhoneNumber,
          ShowReceipt: true,
          rcn: rcd,
          rdt: receiptdate,
          Staff: Staff,
          cstid: PickedCustomerID,
          ordernumber: OrderValueProcessed,
          Collector: PCtx.Username,
        };
        // console.log(AllOrderedItems);
        let OrdersSaved = await PCtx.connectAxios(
          "savesalesdetails.php",
          SalesData,
        );
        // console.log(OrdersSaved);
        if (OrdersSaved.includes("success")) {
          setReceiptDetails(SalesData);
          setOrderInProgress(false);
          setshowReceipt(true);
          setShowProcessing(false);
        }
      } else {
        let unavailable = "";
        for (var b = 0; b < GoodsNotAvailable.length; b++) {
          let newunv =
            b === GoodsNotAvailable.length - 1
              ? GoodsNotAvailable[b]
              : GoodsNotAvailable[b] + ",\n ";
          unavailable = unavailable + newunv;
        }
        setShowProcessing(false);
        PCtx.displayAlert(
          "INSUFFICIENT QUANTITY",
          "The following goods have just been sold out and are no longer available in the stock.\n" +
            unavailable,
          "danger",
        );
      }
      setcannotGenerate(false);
    };

    if (AllOrderedItems.length > 0) {
      Proceed();
    }
  }, [CheckOver]);

  const decryption = (Scramb) => {
    let Permission = false;
    if (PCtx.logged) {
      // Scramb = "U2FsdGVkX1/WscdZ+9IV7bHNnXe+9Ptb9Fcv1faThVI=";
      let Scrambled = Scramb.replace(/\s/g, "");
      var bytes = CryptoJS.AES.decrypt(Scrambled, "143tonybridget");
      let Allowance = bytes.toString(CryptoJS.enc.Utf8);
      Permission = parseInt(Allowance) === 1 ? true : false;
    }
    return Permission;
  };

  const setTheValue = (e) => {
    let vl = e.target.value;
    let nm = e.target.name;

    if (nm === "Cash" && !isNaN(vl)) {
      setCash(vl);
    } else {
      if (nm === "POS" && !isNaN(vl)) {
        setPOS(vl);
      } else {
        if (nm === "Transfer" && !isNaN(vl)) {
          setTransfer(vl);
        }
      }
    }
  };

  const getItemnameSelection = async (it) => {
    setItemProps({
      ItemID: "",
      Converter: "",
      QBulk: "",
      QUnit: "",
      SoldIn: "",
      SP1: "",
      SP2: "",
      SP3: "",
      UP1: "",
      UP2: "",
      UP3: "",
      PackPriceSelected: "",
      UnitPriceSelected: "",
      PUrl: "",
    });

    let goodproperties = await PCtx.connectAxios(
      `getitemdetails.php?version=${Date.now()}`,
      it,
    );
    // console.log(goodproperties);

    setItemProps({
      ItemID: goodproperties.GoodID,
      Converter: goodproperties.Converter,
      QBulk: goodproperties.QBulk,
      QUnit: goodproperties.QUnit,
      SoldIn: goodproperties.Soldin,
      SP1: goodproperties.SP1,
      SP2: goodproperties.SP2,
      SP3: goodproperties.SP3,
      UP1: goodproperties.UP1,
      UP2: goodproperties.UP2,
      UP3: goodproperties.UP3,
      PackPriceSelected: goodproperties.SP1,
      UnitPriceSelected: goodproperties.UP1,
      PUrl: goodproperties.PUrl,
    });

    setdisplay(true);
    setNop("");
    setNou("");
  };

  const secondGetItemnameSelection = async (it) => {
    let Nop = it.nop;
    let Nou = it.nou;
    let itnm = it.Itemname;
    let goodproperties = await PCtx.connectAxios(
      `getitemdetails.php?version=${Date.now()}`,
      itnm,
    );
    let Converter = goodproperties.Converter;
    let QB = goodproperties.QBulk;
    let QU = goodproperties.QUnit;

    let NP = Nop === "" || Nop === null ? 0 : parseFloat(Nop);
    let NU = Nou === "" || Nou === null ? 0 : parseFloat(Nou);
    QB = QB === "" || QB === null ? 0 : parseFloat(QB);
    QU = QU === "" || QU === null ? 0 : parseFloat(QU);
    let thisorder = parseFloat(Converter) * parseFloat(NP) + parseFloat(NU);
    let availableorder = parseFloat(Converter) * QB + QU;

    if (availableorder < thisorder) {
      await setGoodsNotAvailable((prevGoodsNotAvailable) => [
        ...prevGoodsNotAvailable,
        itnm,
      ]);
    }
  };

  const ReConfirmOrderAvailability = async (TheOrders) => {
    setShowProcessing(true);
    setcannotGenerate(true);
    setGoodsNotAvailable([]);
    for (var r = 0; r < TheOrders.length; r++) {
      let theReturn = await secondGetItemnameSelection(TheOrders[r]);
      if (r == TheOrders.length - 1) {
        setCheckOver(!CheckOver);
      }
    }
  };

  const RemovingItems = async (dsIt, amt) => {
    await removeItem(dsIt, amt);
    if (PaymentMode === "Transfer" || PaymentMode === "POS") {
      await removeItem(PaymentMode + " Charges", SurCharge);
    }
  };

  const removeItem = async (dsItem, amount) => {
    // console.log(dsItem);
    await setAllOrderedItems((prevAllOrderedItems) =>
      prevAllOrderedItems.filter((itm) => itm.Itemname !== dsItem),
    );
    await setTotalPayableWithDiscount(
      (prevTotalPayable) => prevTotalPayable - amount,
    );
    await setTotalPayable((prevTotalPayable) => prevTotalPayable - amount);
    if (showDiscount && Discount > 0) {
      setshowDiscount(false);
      setDiscount(0);
      PCtx.displayAlert(
        "DISCOUNT RESET",
        "Please note that the discount is no longer applied. You can reapply it after all your orders have been concluded",
        "warning",
      );
    }
    setSurCharge(0);
    setPaymentMode("Cash");
  };

  const ApplyDiscount = (e) => {
    let dsc = e.target.value;
    if (showDiscount && TotalPayable > 0 && !isNaN(dsc)) {
      let discount = parseFloat(dsc) > 0 ? parseFloat(dsc) : 0;
      setDiscount(discount);
      setTotalPayableWithDiscount(parseFloat(TotalPayable) - discount);
    }
  };

  const ShowDiscountHandler = () => {
    setshowDiscount(!showDiscount);
    if (showDiscount) {
      setDiscount(0);
      setTotalPayableWithDiscount(TotalPayable);
    }
  };

  const StartNewSales = () => {
    window.location.reload();
  };

  const GetOrderNumber = async (OrderValue) => {
    if (OrderValue.length === 10) {
      const ODetails = await PCtx.connectAxios(
        "getthisorderdetails.php",
        OrderValue,
      );
      setOrderValueProcessed(OrderValue);
      // console.log(ODetails);
      if (Array.isArray(ODetails) && ODetails.length > 0) {
        let TT = 0;
        ODetails.forEach((element) => {
          TT += parseFloat(element.subtotal);
        });
        setAllOrderedItems(ODetails);
        setOpenCustomerForm(false);
        setOrderInProgress(true);
        setTotalPayable(TT);
        setTotalPayableWithDiscount(TT);
        setCustomerName(ODetails[0].Buyer);
        setStaff(ODetails[0].Staff);
        setPhoneNumber(ODetails[0].Phone);
      } else {
        PCtx.displayAlert(
          "EMPTY ORDER",
          "No item was found for this order",
          "danger",
        );
      }
    } else {
      PCtx.displayAlert(
        "INVALID ORDER NUMBER",
        "The Order Number you entered is invalid. Please try again and ensure no spaces",
        "danger",
      );
    }
  };

  const IgnoreReceipt = async (CardNo) => {
    let IGN = await PCtx.connectAxios("ignorereceipt.php", CardNo);
    if (IGN.includes("success")) {
      setReload(!Reload);
    }
  };
  const PutOnQueue = async (CardNo) => {
    let QUE = await PCtx.connectAxios("putonqueue.php", CardNo);
    if (QUE.includes("success")) {
      setReload(!Reload);
    }
  };

  const ConfirmClearing = () => {
    setMessage(
      "Are you sure you want to Clear all Pending Orders? This action cannot be reversed.",
    );
    setShowOK(true);
  };

  const ClearOrders = async () => {
    let Clear = await PCtx.connectAxios("clearorders.php", "");
    // console.log(Clear);
    if (Clear.includes("success")) {
      PCtx.displayAlert(
        "Success",
        "All Pending Orders deleted successfully in the database",
        "success",
      );
      setReload(!Reload);
    }
    setShowOK(false);
  };

  // const GetOrderValue = (e) => {
  //   let vl = e.target.value;
  //   vl = vl.toUpperCase();
  //   setOrderValue(vl);
  // };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">SALES</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {OpenCustomerForm && (
          <Row className="mt-2 mb-0 justify-content-around px-3">
            <Col md={12} lg={12} sm={12} xs={12}>
              <Card>
                <Card.Body>
                  <Row className="mt-2 mb-0 justify-content-around px-3">
                    <Col md={5} lg={5} sm={12} xs={5} className="text-start">
                      <Button
                        className="btn btn-sm btn-info"
                        onClick={() => setReload(!Reload)}
                      >
                        REFRESH QUEUE
                      </Button>
                    </Col>
                    <Col md={5} lg={5} sm={12} xs={5} className="text-end">
                      <Button
                        className="btn btn-sm btn-danger"
                        onClick={ConfirmClearing}
                      >
                        CLEAR ALL PENDING ORDERS
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <hr />
            <Col md={12} lg={12} sm={12} xs={12}>
              <Tabs
                defaultActiveKey="Queue"
                id="uncontrolled-tab-example"
                className={`${classes.hide4printing} ${"mb-3"}`}
              >
                <Tab
                  eventKey="Queue"
                  title={`LIVE QUEUE (${AllOrderNumbers.length})`}
                  className={classes.margin4printing}
                >
                  <Table responsive hover striped>
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>CUSTOMER'S NAME</th>
                        <th>ORDER NUMBER</th>
                        <th>AMOUNT</th>
                        <th>DATE</th>
                        <th>IGNORE</th>
                        <th>ACCEPT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {AllOrderNumbers.map((ord, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{ord.OrderCustomer}</td>
                          <td>{ord.OrderNumber}</td>
                          <td>
                            {Number(ord.OrderValue).toLocaleString("en-NG", {
                              minimumFractionDigits: 0,
                            })}
                          </td>
                          <td>{ord.DateSold}</td>
                          <td>
                            <Button
                              className="btn btn-sm btn-danger"
                              onClick={() => IgnoreReceipt(ord.OrderNumber)}
                            >
                              IGNORE
                            </Button>
                          </td>
                          <td>
                            <Button
                              className="btn btn-sm btn-success"
                              onClick={() => GetOrderNumber(ord.OrderNumber)}
                            >
                              ACCEPT
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Tab>
                <Tab
                  eventKey="Ignored"
                  title={`IGNORED ORDERS (${IgnoredOrders.length})`}
                  className={classes.margin4printing}
                >
                  <Table responsive hover striped>
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>CUSTOMER'S NAME</th>
                        <th>ORDER NUMBER</th>
                        <th>AMOUNT</th>
                        <th>DATE</th>
                        <th>PUT ON QUEUE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {IgnoredOrders.map((ord, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{ord.OrderCustomer}</td>
                          <td>{ord.OrderNumber}</td>
                          <td>{ord.OrderValue}</td>
                          <td>{ord.DateSold}</td>
                          <td>
                            <Button
                              className="btn btn-sm btn-danger"
                              onClick={() => PutOnQueue(ord.OrderNumber)}
                            >
                              PUT ON QUEUE
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        )}
        {!OpenCustomerForm && (
          <Row className="justify-content-around">
            {OrderInProgress && (
              <Col
                md={{ span: 10, order: 1 }}
                sm={{ span: 12, order: 2 }}
                xs={{ span: 12, order: 2 }}
                className={classes.hide4printing}
              >
                <Row
                  className={`${classes.hide4printing} justify-content-around`}
                >
                  <Col md={12} sm={12}>
                    <Card>
                      <Card.Header>
                        PLACED ORDERS FOR {CustomerName.toUpperCase()}
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col
                            md={12}
                            sm={12}
                            ref={tableRef}
                            style={{
                              height: "350px",
                              overflowY: "auto",
                              marginBottom: "20px",
                            }}
                          >
                            <Table
                              striped
                              bordered
                              hover
                              style={{ fontFamily: "Times New Roman" }}
                            >
                              <thead>
                                <tr>
                                  <th className="text-center">SN</th>
                                  <th className="text-center">Description</th>
                                  <th className="text-center">Bulk Price</th>
                                  <th className="text-center">Unit Price</th>
                                  <th className="text-center">Sub Total</th>
                                  <th className="text-center">Delete</th>
                                </tr>
                              </thead>
                              <tbody>
                                {AllOrderedItems.map((order, index) => (
                                  <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">
                                      {order.description}
                                    </td>
                                    <td className="text-center">
                                      {isNaN(order.bulkprice) ||
                                      order.bulkprice === 0
                                        ? "-"
                                        : order.bulkprice}
                                    </td>
                                    <td className="text-center">
                                      {isNaN(order.unitprice) ||
                                      order.unitprice === 0
                                        ? "-"
                                        : order.unitprice}
                                    </td>
                                    <td className="text-center">
                                      {order.subtotal}
                                    </td>
                                    <td className="text-center">
                                      <Button
                                        variant="danger"
                                        type="button"
                                        className="btn-sm"
                                        disabled={
                                          order.itemid === "12345"
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          RemovingItems(
                                            order.Itemname,
                                            order.subtotal,
                                          )
                                        }
                                      >
                                        -
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={12} sm={12}>
                    <Card>
                      <Card.Body className="py-1">
                        <Row>
                          <Col
                            md={6}
                            style={{ borderRight: "1px solid brown" }}
                          >
                            <label>
                              <input
                                type="checkbox"
                                onChange={ShowDiscountHandler}
                                checked={showDiscount}
                              />
                              Discount
                            </label>
                            {showDiscount && (
                              <input
                                type="text"
                                placeholder="Enter Amount"
                                readOnly={TotalPayable <= 0}
                                value={Discount}
                                onChange={ApplyDiscount}
                                style={{
                                  width: "100px",
                                  marginLeft: "3px",
                                  borderRadius: "2px",
                                  paddingLeft: "5px",
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card style={{ height: "35px" }}>
                      <Card.Body>
                        <Divider className="m-0">
                          <h4 className="text-success ">
                            Total Payable = ₦
                            {TotalPayableWithDiscount.toLocaleString("en-NG", {
                              minimumFractionDigits: 0,
                            })}
                          </h4>
                        </Divider>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={12} sm={12}>
                    <Card>
                      <Card.Body className="py-1">
                        <Row
                          className="justify-content-center"
                          style={{ backgroundColor: "" }}
                        >
                          <Col md={4} lg={4} xs={4} sm={4}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                Cash
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={Cash}
                                name="Cash"
                                onChange={setTheValue}
                                className="my-0"
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4} xs={4} sm={4}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                POS
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={POS}
                                name="POS"
                                className="my-0"
                                onChange={setTheValue}
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4} xs={12} sm={12}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                Transfer
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={Transfer}
                                name="Transfer"
                                onChange={setTheValue}
                                className="my-0"
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <hr className="p-1 m-1" />
                      </Card.Body>
                    </Card>
                    {/* <Card style={{ height: "35px" }}>
                      <Card.Body>
                        <Divider className="m-0">
                          <h4 className="text-success ">
                            Total Payable = ₦{TotalPayableWithDiscount}
                          </h4>
                        </Divider>
                      </Card.Body>
                    </Card> */}
                  </Col>
                  <Col md={4}>
                    <Button
                      variant="danger"
                      className="w-100 mt-1"
                      onClick={StartNewSales}
                    >
                      CANCEL PAYMENT
                    </Button>
                  </Col>
                  <Col md={4}>
                    <Button
                      variant="success"
                      className="w-100 mt-1"
                      onClick={() => {
                        if (!cannotGenerate) {
                          setcannotGenerate(true);
                          ReConfirmOrderAvailability(AllOrderedItems);
                        }
                      }}
                      disabled={!PaymentModePerfect}
                    >
                      GENERATE RECEIPT
                    </Button>
                  </Col>
                </Row>
              </Col>
            )}

            <Col
              md={{ span: 3, order: 3 }}
              sm={{ span: 12, order: 3 }}
              xs={{ span: 12, order: 3 }}
            >
              {/* <Card>
                <Card.Header className={classes.hide4printing}>
                  RECEIPT
                </Card.Header>
                <Card.Body className={classes.margin4printing}> */}
              <h3 className={classes.hide4printing}>RECEIPT</h3>
              {!OrderInProgress && (
                <Button
                  variant="info"
                  className={`${classes.hide4printing} ${"w-100 mb-3"}`}
                  onClick={StartNewSales}
                >
                  ACCEPT NEW PAYMENT
                </Button>
              )}
              {showReceipt && (
                <TableReceipt Rct={ReceiptDetails} PrintDirectly={true} />
              )}
              {/* </Card.Body>
              </Card> */}
            </Col>
          </Row>
        )}
      </Col>
      {ShowProcessing && (
        <ProcessingModal
          Show={ShowProcessing}
          message={
            "Please be patient, the system is processing each item bought."
          }
        />
      )}
      {ShowOK && (
        <YesAndNoModal2
          message={Message}
          showmodal={ShowOK}
          deleteorder={ClearOrders}
          NextEvent={() => setShowOK(false)}
          modaltype="Error"
        />
      )}
    </Row>
  );
};

export default Sales;
